import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Home = () => {
  // Load Behold Instagram widget script
  useEffect(() => {
    if (window.__bhldScript) return;
    window.__bhldScript = true;
    const s = document.createElement("script");
    s.type = "module";
    s.src = "https://w.behold.so/widget.js";
    document.head.append(s);
  }, []);
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="hero-section min-h-screen flex items-center">
        <div className="container-custom w-full">
          <div className="max-w-4xl">
            <h1 className="brand-display mb-8">
              GPS METHOD™
            </h1>
            <p className="body-large mb-6 max-w-2xl">
              A System for Psychological Presence
            </p>
            <p className="body-medium mb-12 text-secondary max-w-xl">
              Founded by Mel Masry<br />
              Delivered through a professional coaching school
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/method" className="btn-primary">
                Explore the Method
                <ArrowRight className="ml-2" size={20} />
              </Link>
              <Link to="/school" className="btn-secondary">
                The Coaching School
              </Link>
              <Link to="/coaching" className="btn-secondary">
                Private Coaching
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-32 bg-card">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <h2 className="heading-2 mb-8 text-primary">GROUNDING. PRESENCE. SELF-STRUCTURE.</h2>
            <p className="body-medium mb-6">
              The GPS Method™ is a psychologically grounded coaching system designed for actors, coaches, and professionals who require precision in their internal work.
            </p>
            <p className="body-medium mb-6 text-secondary">
              This is not therapy. This is not motivation. This is not a shortcut.
            </p>
            <p className="body-medium text-secondary">
              It is a method for developing internal orientation, psychological readiness, and sustainable presence under professional conditions.
            </p>
          </div>
        </div>
      </section>

      {/* What We Offer */}
      <section className="py-32">
        <div className="container-custom">
          <h2 className="heading-2 mb-16 text-center">WHAT WE OFFER</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="card-standard p-8">
              <h3 className="heading-4 mb-4 text-primary">The Method</h3>
              <p className="body-small mb-6">
                A complete system for understanding and developing psychological presence.
              </p>
              <Link to="/method" className="link-text">
                Learn More →
              </Link>
            </div>
            <div className="card-standard p-8">
              <h3 className="heading-4 mb-4 text-primary">The School</h3>
              <p className="body-small mb-6">
                Professional training for actors and coaches. Small cohorts. Long-term development.
              </p>
              <Link to="/school" className="link-text">
                View Programs →
              </Link>
            </div>
            <div className="card-standard p-8">
              <h3 className="heading-4 mb-4 text-primary">Private Coaching</h3>
              <p className="body-small mb-6">
                Limited, application-based coaching for serious practitioners.
              </p>
              <Link to="/coaching" className="link-text">
                Apply Now →
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Instagram Feed */}
      <section className="py-32" data-testid="instagram-feed-section">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="heading-2 mb-4">FOLLOW THE JOURNEY</h2>
            <a
              href="https://instagram.com/gps1way"
              target="_blank"
              rel="noopener noreferrer"
              className="link-text inline-flex items-center gap-2"
            >
              @gps1way on Instagram
              <ArrowRight size={16} />
            </a>
          </div>
          <div dangerouslySetInnerHTML={{ __html: '<behold-widget feed-id="uSy57a50jtpSltA3hJ79"></behold-widget>' }} />
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-32 bg-card">
        <div className="container-custom text-center">
          <h2 className="heading-2 mb-8">READY TO BEGIN?</h2>
          <p className="body-medium mb-12 max-w-2xl mx-auto text-secondary">
            The GPS Coaching School accepts applications on a rolling basis. Places are limited.
          </p>
          <Link to="/apply" className="btn-primary inline-flex items-center">
            Apply to the School
            <ArrowRight className="ml-2" size={20} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;